import { ScrollContext } from '../../utils/scroll-observer'
import { useContext, useCallback } from 'react'

const ScrollUp = props => {
  const { scrollY } = useContext(ScrollContext)

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [])

  return (
    <a
      onClick={scrollToTop}
      className={`p-2 rounded-md bg-[#1e1e1e] w-fit fixed right-4 opacity-80 ${
        scrollY >= 528 ? 'bottom-4' : 'bottom-[-20%]'
      } shadow-lg z-40 hover:bg-[#1b1b1b] hover:opacity-100 transition-all cursor-pointer`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="w-4 h-4 stroke-[#f9f9f9]"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.5 15.75l7.5-7.5 7.5 7.5"
        />
      </svg>
    </a>
  )
}

export default ScrollUp
